/* @flow */

import React from 'react';
import { Segment, Message } from 'semantic-ui-react';
import ResourceCategory from './ResourceCategory';

type Props = {
  resources: List<BucketResource>,
  onUpdateResource: (resource: BucketResource) => void,
  onCropResource: (resource: BucketResource, conf: CropConfig) => void,
  onRemoveResource: (resource: BucketResource) => void,
  isRemovingResource: boolean,
};

const ResourceList = ({
  resources,
  onUpdateResource,
  onCropResource,
  onRemoveResource,
  isRemovingResource,
}: Props) => {
  const renderContent = () => {
    if (resources && resources.size) {
      // Grouping resources  by category
      return resources
        .groupBy(r => r.type.category)
        .map((resources, category) => (
          <ResourceCategory
            key={category}
            category={category}
            resources={resources.toArray()}
            onUpdateResource={onUpdateResource}
            onCropResource={onCropResource}
            onRemoveResource={onRemoveResource}
            isRemovingResource={isRemovingResource}
          />
        ))
        .toList();
    }

    return (
      <Message
        icon="info circle"
        header="Aucune ressource associée à ce dossier"
      />
    );
  };

  return (
    <Segment attached="bottom">
      {renderContent()}
    </Segment>
  );
};

export default ResourceList;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/components/ResourceList.js